import { useContext } from 'react';
import { CmsClientContext } from './CmsClientContext';
import { CmsClientContextValue } from './types';

export const useCmsClientContext = (): CmsClientContextValue => {
  const context = useContext(CmsClientContext);
  if (context === undefined) {
    throw new Error(
      'useCmsClientContext must be used within a CmsClientProvider',
    );
  }
  return context;
};
